var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var CountdownTimer_1;
import JsxCatalogItem from '@slickdeals/durango/dist/javascript/core/jsxCatalogItem';
import JsxComponent from '../core/jsxComponent';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import { defaultOptions } from '@slickdeals/durango/dist/javascript/decorators/defaultOptions';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { stateable } from '@slickdeals/durango/dist/javascript/decorators/stateable';
import { name as intervalQueueName } from '@slickdeals/durango/dist/javascript/queues/interval/intervalQueue';
import { classNameWithModifier, classNameWithSubClass } from '@slickdeals/durango/dist/javascript/utilities/css';
import { durationFormatAsObject, dateDiffFromNow, getAsDate, Unit, } from '@slickdeals/durango/dist/javascript/utilities/date';
import { isElementVisible } from '@slickdeals/durango/dist/javascript/utilities/dom';
import './descriptionList';
import './icon';
import '../../scss/components/countdownTimer.scss';
/** The name of the module */
export const name = 'CountdownTimer';
export var ClassNames;
(function (ClassNames) {
    ClassNames["JavaScript"] = "js-countdownTimer";
    ClassNames["Default"] = "bp-c-countdownTimer";
})(ClassNames || (ClassNames = {}));
// How often to update the countdown, in milliseconds
// Update every second
const updateInterval = 1000;
/** Dependencies for this module */
export const dependencies = {
    ...Injector.createDependency(intervalQueueName, InjectorScope.Singleton),
};
export var Units;
(function (Units) {
    Units["Days"] = "days";
    Units["Hours"] = "hours";
    Units["Minutes"] = "minutes";
    Units["Seconds"] = "seconds";
})(Units || (Units = {}));
let CountdownTimer = CountdownTimer_1 = class CountdownTimer extends JsxCatalogItem {
    /**
      * Create a CountdownTimer UI component
      *
      * @param intervalQueue IntervalQueue instance
      * @param options Data and options to initialize the component with
   */
    constructor(intervalQueue, options = {}) {
        super(options);
        /** The current units being displayed in the UI */
        this.unitElements = {
            days: null,
            hours: null,
            minutes: null,
            seconds: null,
        };
        // guard against initial constructor call when importing(?)
        if (intervalQueue === undefined) {
            return;
        }
        this.intervalQueue = intervalQueue;
        // Initialize the state
        const initState = {
            endTime: CountdownTimer_1.createEndDate(options.endTime),
            duration: {
                duration: null,
                days: null,
                hours: null,
                minutes: null,
                seconds: null,
            },
            endText: options.endText,
        };
        // Initialize the module's state
        this.initState(initState);
    }
    /**
      * Performs any necessary initialization for the component
      */
    async init() {
        super.init();
        this.element = await JsxCatalogItem.loadElement(name, this.options);
        // guard against initial constructor call when importing(?)
        if (!this.element) {
            return;
        }
        // Get all the elements for updating the units
        if (!this.options.tiny) {
            this.unitElements.days = this.element.querySelector('[data-unit="days"]');
            this.unitElements.hours = this.element.querySelector('[data-unit="hours"]');
        }
        this.unitElements.minutes = this.element.querySelector('[data-unit="minutes"]');
        this.unitElements.seconds = this.element.querySelector('[data-unit="seconds"]');
        // Listen for window resizes to start/stop countdown
        window.addEventListener('resize', this.onResize.bind(this));
        // Start the countdown if the element is visible
        if (isElementVisible(this.element)) {
            this.startTimer();
        }
    }
    /**
     * Creates a label element
     *
     * @param {Props} props Properties to populate Label with
     */
    createElement(props) {
        // TODO: clean this id generation up
        const id = `df${Math.floor(Math.random() * 1000)}${Math.floor(Math.random() * 1000)}-${name}`;
        let daysAndHours = '';
        if (!props.tiny) {
            daysAndHours = (JsxComponent.parseJsx("fragment", null,
                JsxComponent.parseJsx("dt", { className: "bp-c-countdownTimer_label bp-c-countdownTimer_label--days" }, "Days"),
                JsxComponent.parseJsx("dd", { className: "bp-c-countdownTimer_count bp-c-countdownTimer_count--days", "data-unit": "days" }, "000"),
                JsxComponent.parseJsx("dt", { className: "bp-c-countdownTimer_label bp-c-countdownTimer_label--hours" }, "Hours"),
                JsxComponent.parseJsx("dd", { className: "bp-c-countdownTimer_count bp-c-countdownTimer_count--hours", "data-unit": "hours" }, "00")));
        }
        return (JsxComponent.parseJsx("div", { id: id, className: "bp-c-countdownTimer js-button", "data-end-time": props.endTime, "data-tiny": props.tiny ? "true" : "", "data-catalog-item": name, "data-catalogItem": name },
            JsxComponent.parseJsx("dl", { className: "bp-c-descriptionList bp-c-descriptionList--unstyled bp-c-countdownTimer_units" },
                daysAndHours,
                JsxComponent.parseJsx("dt", { className: "bp-c-countdownTimer_label bp-c-countdownTimer_label--minutes" }, "Minutes"),
                JsxComponent.parseJsx("dd", { className: "bp-c-countdownTimer_count bp-c-countdownTimer_count--minutes", "data-unit": "minutes" }, "00"),
                JsxComponent.parseJsx("dt", { className: "bp-c-countdownTimer_label bp-c-countdownTimer_label--seconds" }, "Seconds"),
                JsxComponent.parseJsx("dd", { className: "bp-c-countdownTimer_count bp-c-countdownTimer_count--seconds", "data-unit": "seconds" }, "00"))));
    }
    /**
       * Starts the countdown timer
       */
    startTimer() {
        // Add the update function to the interval queue
        this.queueKey = this.intervalQueue.add({
            callback: this.update.bind(this),
            delay: updateInterval,
        });
        this.isTimerActive = true;
    }
    /**
      * Stops the countdown timer
      */
    stopTimer() {
        // Remove the update function from the interval queue
        this.intervalQueue.remove(this.queueKey);
        this.isTimerActive = false;
    }
    /**
      * Monitors page resize to start/stop timer based on visibility of the element
      */
    onResize() {
        const { duration } = this.getState();
        if (isElementVisible(this.element) && !this.isTimerActive && duration.seconds) {
            this.startTimer();
        }
        else if (!isElementVisible(this.element) && this.isTimerActive) {
            this.stopTimer();
        }
    }
    /**
      * Triggers a UI update for the unit elements based on the time now and the eventual end time
      *
      * @param intervalCounter Iteration number from IntervalQueue
      */
    update() {
        // Find out what the current difference in seconds is
        const diff = dateDiffFromNow(this.getState().endTime);
        // Parse and format the duration into a DurationObject
        const newDuration = durationFormatAsObject(diff);
        // Get the current duration
        const { duration } = this.getState();
        // If the current duration is empty, then set the countdown timer to active
        // TODO: Bind state updates to UI elements
        if (duration.duration === null) {
            this.setAsActive();
            // If the new duration is less than a second, then update all units to '0' and stop the timer
        }
        else if (newDuration.duration <= 1000) {
            if (!this.options.tiny) {
                newDuration.days = 0;
                newDuration.hours = 0;
            }
            newDuration.minutes = 0;
            newDuration.seconds = 0;
            this.stopTimer();
            this.displayEndText();
        }
        // Update the days label if it is different
        if (duration.days !== newDuration.days && !this.options.tiny) {
            this.updateDays(newDuration.days);
        }
        // Update the hours label if it is different
        if (duration.hours !== newDuration.hours && !this.options.tiny) {
            this.updateHours(newDuration.hours);
        }
        // Update the minutes label if it is different
        if (duration.minutes !== newDuration.minutes) {
            this.updateMinutes(newDuration.minutes);
        }
        // Update the seconds label if it is different
        if (duration.seconds !== newDuration.seconds) {
            this.updateSeconds(newDuration.seconds);
        }
        // Update the state with the new duration
        this.setState({
            duration: newDuration,
        });
    }
    /**
      * If text is supplied for display when the countdown ends, display it
      */
    displayEndText() {
        if (this.getState().endText) {
            const dlElm = this.element.querySelector('dl');
            const endTextElm = document.createElement('span');
            const endTextNode = document.createTextNode(this.getState().endText);
            endTextElm.classList.add(classNameWithSubClass(ClassNames.Default, 'endText'));
            endTextElm.appendChild(endTextNode);
            dlElm.replaceWith(endTextElm);
        }
    }
    /**
      * Update a unit UI component to a new value
      *
      * @param key The unit to be updated
      * @param value The value to update the unit to
      */
    updateUnitElement(key, value) {
        if (this.options.tiny) {
            this.unitElements[key].textContent = value.toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
            return;
        }
        this.unitElements[key].textContent = value.toString();
    }
    /**
      * Update the days UI component to a new value
      *
      * @param value The value to update the unit to
      */
    updateDays(value) {
        this.updateUnitElement(Units.Days, value);
    }
    /**
      * Update the hours UI component to a new value
      *
      * @param value The value to update the unit to
      */
    updateHours(value) {
        this.updateUnitElement(Units.Hours, value);
    }
    /**
      * Update the minutes UI component to a new value
      *
      * @param value The value to update the unit to
      */
    updateMinutes(value) {
        this.updateUnitElement(Units.Minutes, value);
    }
    /**
      * Update the seconds UI component to a new value
      *
      * @param value The value to update the unit to
      */
    updateSeconds(value) {
        this.updateUnitElement(Units.Seconds, value);
    }
    /**
      * Set the CountdownTimer UI as active
      */
    setAsActive() {
        this.element.classList.remove(classNameWithModifier(ClassNames.Default, 'inactive'));
    }
    /**
      * Create an actual Date object for the countdown end date, based on the supplied value being:
      *      - A date string (e.g. January 1, 2025 12:00 AM)
      *      - A relative time in seconds (e.g. +600 to add 10 minutes or -300 to subtract 5 minutes)
      *      - A UNIX timestamp
      *      - It's already a JavaScript Date object
      *
      * @param endTime Time string or UNIX timestamp representing the time to use
      */
    static createEndDate(endTime) {
        return getAsDate(endTime, Unit.Second);
    }
    /**
     * Create a countdownTimer Object from an existing countdownTimer element on the DOM through data attributes
     *
     * @param countdownTimerElement the countdown timer element
     */
    static createFromDataAttributes(countdownTimerElement) {
        const options = {
            id: countdownTimerElement.id,
            endTime: countdownTimerElement.dataset.endTime,
            tiny: !!countdownTimerElement.dataset.tiny,
        };
        // Create and return the object instance
        return new CountdownTimer_1(Injector.get(intervalQueueName, InjectorScope.Singleton), options);
    }
};
CountdownTimer = CountdownTimer_1 = __decorate([
    stateable(name),
    injectable(name, dependencies),
    defaultOptions({
        endTime: 0,
        endText: '',
        tiny: false,
    }),
    catalogItem(name, {
        instantiate: {
            fromHydrationQueue: true,
            fromDom: true,
            fromMutation: true,
        }
    })
], CountdownTimer);
export default CountdownTimer;
